module.exports = __webpack_public_path__ + "static/media/YDJSPL.fe4ba7fb.jpg";